var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import theme from '../../../landing/components/core/themes/theme';
import { AssignmentsLayout } from './components/AssignmentsLayout';
import { ASSIGNMENTS_ROUTES, getBaseName } from './constants/routes';
import { AssignmentsList } from './pages/AssignmentsList';
import { AssignmentDetails } from './pages/AssignmentDetails';
import { CreateAssignment } from './pages/CreateAssignment';
import { useAppGoogleAnalytics } from '../../../shared_app/hooks/useAppGoogleAnalytics';
import { ASSIGNMENTS_EVENTS, ASSIGNMENTS_EVENT_CATEGORIES, } from './constants/analytics';
import { useFetch } from '@hn-front/utils';
import { useGroupInfo } from './hooks/useGroupInfo';
var Assignments = function (_a) {
    var _b, _c, _d;
    var groupId = _a.groupId;
    var ga = useAppGoogleAnalytics();
    useEffect(function () {
        ga === null || ga === void 0 ? void 0 : ga.sendEventAsTeacher({
            category: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage,
            action: ASSIGNMENTS_EVENTS.assign_default_page_visit,
        });
    }, [ga]);
    var response = useFetch("/api/teachers/assignments/unlock?id=" + groupId).response;
    var _e = useGroupInfo(groupId), groupInfo = _e.response, isLoading = _e.isLoading;
    var allowAssignments = (_b = groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.assignments) === null || _b === void 0 ? void 0 : _b.allowAssignments;
    return (_jsx(Routes, { children: _jsxs(Route, __assign({ element: _jsx(AssignmentsLayout, { groupInfo: groupInfo, groupInfoLoading: isLoading }, void 0) }, { children: [_jsx(Route, { path: '/', element: _jsx(AssignmentsList, { groupId: groupId, lockReason: response === null || response === void 0 ? void 0 : response.unlockWith, allowAssignments: (_c = groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.assignments) === null || _c === void 0 ? void 0 : _c.allowAssignments, wayToObtainAccess: (_d = groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.assignments) === null || _d === void 0 ? void 0 : _d.wayToObtainAccess }, void 0) }, void 0), _jsx(Route, { path: ASSIGNMENTS_ROUTES.assignmentDetails, element: _jsx(AssignmentDetails, { groupId: groupId }, void 0) }, void 0), allowAssignments && (_jsx(Route, { path: ASSIGNMENTS_ROUTES.createAssignment, element: _jsx(CreateAssignment, { groupId: groupId }, void 0) }, void 0)), _jsx(Route, { path: ASSIGNMENTS_ROUTES.createAssignmentFromAnother, element: _jsx(CreateAssignment, { groupId: groupId }, void 0) }, void 0), _jsx(Route, { path: ASSIGNMENTS_ROUTES.createAssignmentFromAnotherForStudent, element: _jsx(CreateAssignment, { groupId: groupId }, void 0) }, void 0), _jsx(Route, { path: '*', element: _jsx(Navigate, { to: '/', replace: true }, void 0) }, void 0)] }), void 0) }, void 0));
};
var AssignmentsApp = function (_a) {
    var groupId = _a.groupId;
    var basename = useMemo(function () { return getBaseName(window.location.pathname); }, []);
    return (_jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsx(BrowserRouter, __assign({ basename: basename }, { children: _jsx(Assignments, { groupId: groupId }, void 0) }), void 0) }), void 0));
};
export { Assignments };
export default AssignmentsApp;
